(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TronWeb", [], factory);
	else if(typeof exports === 'object')
		exports["TronWeb"] = factory();
	else
		root["TronWeb"] = factory();
})(self, () => {
return 